<template>
    <a-drawer :title="$t('program.program_logs_title' /* 学术日程更新日志 */)" width="85%" placement="right" :closable="true" :visible="visible" @close="handleDrawerClose">
        <a-spin :spinning="loading">
            <a-form class="mb20" :form="form" layout="inline">
                <a-form-item :label="$t('program.query_start_date' /* 查询开始日期 */)">
                    <a-date-picker style="width: 150px" v-decorator="['start_time']" :placeholder="$t('program.start_date_placeholder' /* 开始日期 */)" />
                </a-form-item>
                <a-form-item :label="$t('program.query_end_date' /* 查询截止日期 */)">
                    <a-date-picker style="width: 150px" v-decorator="['end_time']" :placeholder="$t('program.end_date_placeholder' /* 结束日期 */)" />
                </a-form-item>
                <a-form-item :label="$t('program.type' /* 类型 */)">
                    <a-select style="width: 150px" :placeholder="$t('formConfig.please_select' /* 请选择 */)" v-decorator="['type']">
                        <a-select-option v-for="item in optionList" :key="item.value" :value="item.value">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="handleSearchEvent">{{ $t('web.query' /* 查询 */) }}</a-button>
                </a-form-item>
            </a-form>

            <!-- 表格 -->
            <a-table
                ref="table"
                :rowKey="record => record.id"
                :columns="columns"
                :data-source="dataSource"
                :pagination="pagination"
                @change="handleTableChange"
                @showSizeChange="handleTableChange"
                :scroll="{ x: 1000 }"
            ></a-table>
        </a-spin>
    </a-drawer>
</template>

<script>
import moment from 'moment';

const optionList = [
    { value: 0, name: '全部' },
    { value: 'Session', name: 'Session' },
    { value: '日程', name: '日程' },
    { value: '任务', name: '任务' }
];
export default {
    name: 'ProgramLogsDrawer',
    props: {},
    components: {},
    data() {
        return {
            visible: false,
            dataSource: [],
            loading: false,
            form: this.$form.createForm(this),
            optionList,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showTotal: total => this.$t('web.pagination_total', { value: total } /* 共 {total} 条 */),
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '30', '50', '100']
            },
            columns: [
                {
                    title: this.$t('program.table_column_id' /* 编号 */),
                    dataIndex: 'id',
                    align: 'left',
                    fixed: 'left',
                    width: 120
                },
                {
                    title: this.$t('program.type' /* 类型 */),
                    dataIndex: 'type',
                    align: 'left',
                    width: 120
                },
                {
                    title: this.$t('program.table_column_notice' /* 更新说明 */),
                    dataIndex: 'notice',
                    align: 'left'
                },
                {
                    title: this.$t('program.table_column_create_time' /* 更新时间 */),
                    dataIndex: 'create_time',
                    align: 'left',
                    width: 180
                },
                {
                    title: this.$t('program.table_column_name' /* 操作人 */),
                    dataIndex: 'name',
                    align: 'left',
                    width: 200
                }
            ]
        };
    },
    computed: {},
    methods: {
        show() {
            this.visible = true;
            this.getDataList();
        },
        //关闭抽屉
        handleDrawerClose() {
            this.dataSource = [];
            this.form.resetFields();
            this.visible = false;
        },
        // 获取列表数据
        getDataList() {
            let data = {
                ...this.form.getFieldsValue(),
                page: this.pagination.current,
                limit: this.pagination.pageSize
            };
            data.start_time = data.start_time ? moment(data.start_time).format('YYYY-MM-DD') : '';
            data.end_time = data.end_time ? moment(data.end_time).format('YYYY-MM-DD') : '';
            this.loading = true;
            this.$request
                .get({ url: 'getProgramLogs', data })
                .then(res => {
                    this.dataSource = res.data.data;
                    this.pagination.total = Number(res.data.count);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 表格变化
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.getDataList();
        },
        // 搜索
        handleSearchEvent() {
            this.pagination.current = 1;
            this.getDataList();
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang='less' scoped>
::v-deep .ant-drawer-body {
    max-height: 90vh;
    overflow-y: auto;
}
</style>